import React from 'react';

export default function ListItemControl({ label, children, ...props }) {
  return (
    <div className="ListItemControl" {...props}>
      <div className="ListItemControl-label">{label}</div>
      <div className="ListItemControl-element">{children}</div>
    </div>
  );
}